<template>
  <div>
    <el-dialog width="800px" :close-on-press-escape="false" :close-on-click-modal="false" :modal-append-to-body="false"
               title="发布询单" :visible.sync="dialogVisible" :before-close="handleClose">
      <div class="content">
        <div>
          <el-form ref="form" :model="form" label-width="110px" label-position="right" :rules="rules">
            <el-form-item label="CAS号" prop="cas_no">
              <!-- <el-input v-model="form.cas_no" placeholder="请输入CAS号" @blur="querySearch"/> -->
              <el-autocomplete ref="casAutocomplete" class="inline-input" v-model="form.cas_no"
                               :fetch-suggestions="getInner"
                               placeholder="请输入CAS号、中文名称、英文名称" :trigger-on-focus="false" :debounce="300"
                               @select="handleCasSelect" @input="onInput" clearable :style="{ width: '100%' }"
                               :value-key="'value'" :select-when-unmatched="false">
                <template slot-scope="{ item }">
                  <div class="suggestion-item">
                    <div class="suggestion-content">
                      <span class="cas-no">{{ item.cas_no || '--' }}</span>
                      <span class="separator">|</span>
                      <span class="name">{{ item.name || '--' }}</span>
                    </div>
                  </div>
                </template>
              </el-autocomplete>
            </el-form-item>
            <el-form-item label="需求量" prop="number">
              <el-input v-model="form.number" placeholder="请输入需求量">
                <el-select style="width: 100px;" prop="unit" v-model="form.unit" slot="append" class="unit-select"
                           placeholder="请选择单位">
                  <el-option v-for="i in unitList" :key="i.id" :label="i.label" :value="i.label"></el-option>
                </el-select>
              </el-input>
            </el-form-item>
            <el-form-item label="是否接受定制" prop="is_quotes">
              <el-checkbox-group v-model="form.is_quotes">
                <el-checkbox :label="1">无货时接受定制报价</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="发票类型" prop="invoice_type">
              <el-select v-model="form.invoice_type" placeholder="请选择发票类型" :style="{ width: '100%' }">
                <el-option label="增值税专用发票（13%）" value="1"></el-option>
                <el-option label="增值税普通发票" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="询单有效期" prop="valid_day">
              <el-select v-model="form.valid_day" placeholder="请选择" :style="{ width: '100%' }">
                <el-option label="1天" :value="1">
                </el-option>
                <el-option label="3天" :value="3">
                </el-option>
                <el-option label="1周" :value="7">
                </el-option>
                <el-option label="1个月" :value="30">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="寄往地区" prop="district">
              <el-cascader v-model="form.district" :options="areaOptions" :props="{ expandTrigger: 'hover' }"
                           :style="{ width: '100%' }"></el-cascader>
            </el-form-item>
            <el-form-item label="期望价格" prop="expected_price">
              <el-input v-model="form.expected_price" placeholder="请输入期望价格"/>
            </el-form-item>
            <el-form-item label="备注">
              <el-input v-model="form.remark" placeholder="请输入备注"/>
            </el-form-item>
            <el-form-item>
              <el-button @click="handleConfirm" type="primary" :style="{ width: '100%' }">获取报价</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="image-box">
          <img class="qrcode" :src="configInfo.wechat_qrcode">
          <img class="bj-image" src="../../static/index/help/weixin1.png">
        </div>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import {purchaseAdd, checkCasNo, purchaseDetail} from "@/api/modules/user";
import {getAreaOptions, getCasOptions} from "@/api/modules/common";

export default {
  name: "post_Inquiry",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
      form: {
        cas_no: "",
        unit: "",
        number: "",
        invoice_type: "",
        district: [],
        expected_price: "",
        remark: "",
        valid_day: "",
        is_quotes: "",
      },
      rules: {
        cas_no: [{required: true, message: "请输入CAS号", trigger: "blur"}],
        number: [{required: true, message: "请输入需求量", trigger: "blur"}],
        unit: [{required: true, message: "请选择单位", trigger: "change"}],
        invoice_type: [
          {required: true, message: "请选择发票类型", trigger: "blur"},
        ],
        district: [
          {required: true, message: "请选择收货地区", trigger: "blur"},
        ],
        expected_price: [{
          validator: (rule, value, callback) => {
            if (!value) {
              // 如果为空，则通过验证（非必填）
              callback();
            } else {
              const price = Number(value);
              if (isNaN(price)) {
                callback(new Error('请输入有效的数字'));
              } else if (price <= 0) {
                callback(new Error('期望价格必须大于0'));
              } else {
                callback();
              }
            }
          },
          trigger: 'blur'
        }],
        valid_day: [
          {required: true, message: "请选择询单有效期", trigger: "change"},
        ]
      },
      areaOptions: [],
      selectedCasItem: null, // 保存选中的CAS项
    };
  },
  computed: {
    configInfo() {
      return this.$store.state.config.config;
    },
    unitList() {
      return this.$store.state.config.unitList
    }
  },
  created() {
    this.init();
  },
  methods: {
    // 输入防抖处理
    onInput() {
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }
      this.searchTimer = setTimeout(() => {
        // 可以在这里添加输入验证逻辑
      }, 300);
    },

    // 处理CAS选择
    handleCasSelect(item) {
      if (item && typeof item === 'object') {
        this.form.cas_no = item.value || item.cas_no || item.name || '';
        this.selectedCasItem = item; // 保存选中的CAS项
      }
    },
    // 获取搜索建议
    async getInner(queryString, cb) {
      if (!queryString || queryString.trim().length < 1) {
        cb([]);
        return;
      }

      try {
        this.isLoading = true;
        const res = await getCasOptions({keyword: queryString.trim()});

        if (res.data && res.data.code === 10000 && res.data.data) {
          // 确保返回的数据格式正确
          let suggestions = [];
          if (Array.isArray(res.data.data)) {
            suggestions = res.data.data;
          } else if (res.data.data.data && Array.isArray(res.data.data.data)) {
            suggestions = res.data.data.data;
          } else if (res.data.data.map && Array.isArray(res.data.data.map)) {
            suggestions = res.data.data.map;
          }

          // 格式化建议数据
          const formattedSuggestions = suggestions.map(item => {
            const displayValue = item.cas_no || item.name || item.name_en || '';
            return {
              ...item,
              value: displayValue,
              label: displayValue
            };
          });

          cb(formattedSuggestions);
        } else {
          cb([]);
        }
      } catch (error) {
        console.error('获取搜索建议失败:', error);
        this.$message.error('获取搜索建议失败，请稍后重试');
        cb([]);
      } finally {
        this.isLoading = false;
      }
    },

    // 用户点击确认按钮
    handleConfirm() {
      // let formData = JSON.parse(JSON.stringify(this.formList));
      let formData = JSON.parse(JSON.stringify([this.form]));
      for (let i = 0; i < formData.length; i++) {
        let data = formData[i];
        if (data.cas_no == "") {
          this.$message.error({
            message: "请选择CAS编号",
            duration: 2000,
            offset: 200,
          });
          return;
        }

        // 验证CAS号是否来自搜索建议
        if (!this.selectedCasItem || this.selectedCasItem.value !== this.form.cas_no) {
          this.$message.error({
            message: "请从搜索建议中选择CAS编号",
            duration: 2000,
            offset: 200,
          });
          return;
        }
        if (data.number == "") {
          this.$message.error({
            message: "请输入采购单的需求量",
            duration: 2000,
            offset: 200,
          });
          return;
        }
        if (data.unit == "") {
          this.$message.error({
            message: "请选择采购单的产品单位",
            duration: 2000,
            offset: 200,
          });
          return;
        }
        if (!data.is_quotes) {
          data.is_quotes = false
        }
        if (data.invoice_type == "") {
          this.$message.error({
            message: "请选择采购单的发票类型",
            duration: 2000,
            offset: 200,
          });
          return;
        } else {
          data.invoice_type = Number(data.invoice_type);
        }
        if (data.valid_day == "") {
          this.$message.error({
            message: "请输入采购单的询单有效期",
            duration: 2000,
            offset: 200,
          });
          return;
        } else {
          if (data.valid_day <= 0) {
            this.$message.error({
              message: "采购单的询单有效期不能小于等于0",
              duration: 2000,
              offset: 200,
            });
            return;
          }
        }
        if (data.district.length == 0) {
          this.$message.error({
            message: "请选择采购单的寄往地区",
            duration: 2000,
            offset: 200,
          });
          return;
        }
        if (data.expected_price) {
          // 判断价格是否为数字
          if (!/^\d+(\.\d+)?$/.test(data.expected_price)) {
            this.$message.error({
              message: "请输入采购单正确的期望价格",
              duration: 2000,
              offset: 200,
            });
            return;
          }
          // 判断价格是否大于0
          if (data.expected_price <= 0) {
            this.$message.error({
              message: "请输入采购单正确的期望价格",
              duration: 2000,
              offset: 200,
            });
          }
        }
      }


      purchaseAdd({info: formData}).then((res) => {
        if (res.data.code == 10000) {
          this.$message.success({
            message: res.data.message,
            duration: 2000,
            offset: 200,
          });
          this.$router.push('/user/purchase/post');
        } else {
          this.$message.error({
            message: res.data.message,
            duration: 2000,
            offset: 200,
          });
        }
      });
    },
    handleClose() {
      this.$emit('close')
    },
    async querySearch(e) {
      if (e.target.value.trim()) {
        let res = await checkCasNo(e.target.value);
        if (res.data.code != 10000) {
          this.$message.error({
            message: "cas号不存在请重新输入",
            duration: 2000,
            offset: 200,
          });
          setTimeout(() => {
            this.formList[0].cas_no = "";
          }, 1000);
        }
      }
    },
    init() {
      // 获取区域选项
      getAreaOptions().then((res) => {
        this.areaOptions = res.data.data.map((item) => {
          return {
            value: item.id,
            label: item.name,
            children: item.children.map((item) => {
              return {
                value: item.id,
                label: item.name,
                children: item.children.map((item) => {
                  return {
                    value: item.id,
                    label: item.name,
                  };
                }),
              };
            }),
          };
        });
      });
    },
  }
}
</script>
<style scoped lang="scss">

.content {
  display: flex;
  justify-content: space-between;
}

.suggestion-item {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.image-box {
  flex: 1;
  margin-left: 24px;
  padding-left: 24px;
  position: relative;

  .bj-image {
    position: relative;
    width: 100%;
    top: 0;
  }

  .qrcode {
    position: absolute;
    width: 100px;
    height: 100px;
    top: 51px;
    left: 58px;
    z-index: 99;
  }
}
</style>
